export const settingsKeys = {
    all: ['settings'] as const,
    eapSettings: () => [...settingsKeys.all, 'eap'] as const,
    eapList: () => [...settingsKeys.eapSettings(), 'list'] as const,
    eapDetail: (id: string) => [...settingsKeys.eapSettings(), id] as const,
    configurations: () => [...settingsKeys.all, 'configurations'] as const,
    configList: <TParams>(params?: TParams) => [...settingsKeys.configurations(), 'list', params] as const,
    configDetail: (id: string) => [...settingsKeys.configurations(), id] as const,
    automationRules: () => [...settingsKeys.all, 'automation-rules'] as const,
    trainingSettings: () => [...settingsKeys.all, 'training-settings'] as const,
    predefinedComments: () => [...settingsKeys.all, 'predefined-comments'] as const,
    predefinedCommentsList: (showOnlyActive: boolean) =>
        [...settingsKeys.predefinedComments(), 'list', showOnlyActive] as const,
    predefinedCommentDetail: (id?: string) => [...settingsKeys.predefinedComments(), 'detail', id] as const,
    operatorCustomNotifications: () => [...settingsKeys.all, 'operator-custom-notifications'] as const,
    operatorCustomNotificationsList: (showInactive: boolean) =>
        [...settingsKeys.operatorCustomNotifications(), 'list', showInactive] as const,
    operatorCustomNotificationDetail: (id?: string) =>
        [...settingsKeys.operatorCustomNotifications(), 'detail', id] as const,
    operatorTriggerCatalogue: (deviceTypeIds: string[]) =>
        [
            ...settingsKeys.operatorCustomNotifications(),
            'trigger-catalogue',
            deviceTypeIds.toSorted((first, second) => first.localeCompare(second)),
        ] as const,
    lmsIntegration: () => [...settingsKeys.all, 'lms-integration'] as const,
    lmsTrainingRegistrations: () => [...settingsKeys.lmsIntegration(), 'training-registrations'] as const,
    lmsMapping: () => [...settingsKeys.lmsIntegration(), 'mapping'] as const,
    lmsPocFields: () => [...settingsKeys.lmsIntegration(), 'poc-fields'] as const,
};
